<template>
    <div>
      <div class="zhong">
        <div class="block">
          <el-input
                    class="inputofelementui"
                    placeholder="搜索资源"
                    v-model="input"
                    clearable>
                    <el-button class="bindsousuo" slot="append" type="primary" icon="el-icon-search" @click="gotoSearch">搜索</el-button>
            </el-input>
            <el-button class="leftto5" :disabled='sysuser && sysuser.vip_Lv && sysuser.vip_Lv < 1 ? true : false' @click="toziyuankudaochu" :loading="loading">资源库导出</el-button>
            <!-- <el-button class="leftto5" @click="toziyuankudaochu" :loading="loading">资源库导出</el-button> -->
        </div>

      </div>
      <div class="zhongtwo">
        <div class="zhongtwodiv one">
          <el-cascader
                  placeholder="城市"
                  v-model="city"
                  :options="cityoptions"
                  :props="{ expandTrigger: 'hover' }"
                  @change="handleChangecity">
          </el-cascader>
          <div class="fenlei"><i class="iconfont icon-xiangzuoshouqi"></i><i class="iconfont icon-xiangzuoshouqi secondiconfont">{{fenleidetailcity}}</i></div>
        </div>
        <div class="zhongtwodiv">
          <el-cascader
                  placeholder="行业"
                  v-model="work"
                  :options="optionswork"
                  :props="{ expandTrigger: 'hover' }"
                  @change="handleChangework">
          </el-cascader>
          <div class="fenlei"><i class="iconfont icon-xiangzuoshouqi"></i><i class="iconfont icon-xiangzuoshouqi secondiconfont">{{fenleidetailwork}}</i></div>
        </div>
        <div class="zhongtwodiv">
          <el-cascader
                    placeholder="参保人数"
                    v-model="people"
                    :options="options"
                    :props="{ expandTrigger: 'hover' }"
                    @change="handleChangepeople">
          </el-cascader>
          <div class="fenlei"><i class="iconfont icon-xiangzuoshouqi"></i><i class="iconfont icon-xiangzuoshouqi secondiconfont">{{fenleidetailpeople}}</i></div>
        </div>
      </div>
      <div class="zhong" style="overflow: auto; height: 600px;">
        <div class="companyItemCont" v-for="item in resourcelist" :key="item.Id" @click="Todetail(item.Id)">
          <div class="companyItem">
            <div class="head">{{item.Company_Name[0]}}</div>
            <div class="info">
              <div class="name">{{item.Company_Name}}</div>
              <div class="tags">
                <div class="industry">{{item.Registered_Capital?(item.Registered_Capital+' | '):"- | "}}
                            {{item.Incorporation_Date}}</div>
              </div>
            </div>
          </div>
          <div class="companyItemTags">
            <div class="ItemTags_r">{{item.contactNum}}条联系方式</div>
            <div class="ItemTags_l">{{item.Trade?item.Trade:""}}</div>
          </div>
        </div>
      </div>
      <ModalNoToken ref="token" v-if="token"></ModalNoToken>
      <el-pagination
            v-show="!token"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="num"
            background
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="prev, pager, next,jumper,sizes"
            :page-sizes="[10, 100, 1000, 2500 ,5000]"
            
        >
        <!-- style="position: fixed;bottom: 0;" -->
        </el-pagination>
    </div>
</template>
<script>
// import work from './../config/fields/city'
import ModalNoToken from '../components/modal-notoken.vue'
import citys from './../config/fields/work'
import * as XLSX from 'xlsx'
export default {  
    components: {
      ModalNoToken
    },
    mounted() {
      this.input = sessionStorage.getItem('search') || ''

      
      // 实现滚动页面的监听
      // if(localStorage.getItem('token')) {
      //   setTimeout(() => {
      //     window.addEventListener("scroll", this.watchScroll);
      //   }, 100);
      // }
      this.getwork()
      this.getlist()
      this.getmount()
      this.getmyself()
    },  
    // beforeRouteLeave(to,from,next) {
    //     next(() => {
    //       window.removeEventListener("scroll", this.watchScroll);

    //     })

    // },
    data() {
        return {
            num:10,
            pageNo:1,
            pageSize:10,
            fenleidetailcity:'北京市——北京市' ,
            fenleidetailpeople:'',
            token:!localStorage.getItem('token'),
            city:['北京市','北京市'],
            work:'',
            people:'',
            cityoptions: citys,
            optionswork: [],
            value:"",
            options: [{
                value: '',
                label: '全部'
            },
            {
              value: '0-10',
              label: '10人以下'
            },
            {
              value: '10-50',
              label: '10-50人'
            },
            {
              value: '50-100',
              label: '50-100人'
            },
            {
              value: '100-200',
              label: '100-200人'
            },
            {
              value: '200-1000',
              label: '200人以上'
            }
          ],
            fenleidetail:'',
            // 行业的一个数组,
            input:"",
            resourcelist:[],
            pageindex:1,
            // loading:false,
            fenleidetailwork:'',
            sysuser: JSON.parse(localStorage.getItem('sysuser')) ,
            tableData: [
              { name: '张三', age: 18, gender: '男' },
              { name: '李四', age: 20, gender: '女' },
              { name: '王五', age: 22, gender: '男' }
            ],
            loading:false,
            userinfo:{}



        }
    },
    methods :{
      handleCurrentChange(e) {
        this.pageNo = e
        this.getlist()
      },
      handleSizeChange(e) {
        this.pageSize = e
        this.pageNo = 1
        this.getlist()

      },
      getmyself() {
        this.$store.dispatch('wxuser/GetMySelf').then(res => {
          console.log(res.data.Data,'什么东西')
          this.userinfo = res.data.Data

        })
      },
      toziyuankudaochu() {
        // 资源库导出  首先鉴定他有没有登陆
        if(this.token) {
          return this.$message.info('您还没有登录,请先登录然后进行资源库导出')
        }
        // 然后判断是不是会员
        if(this.userinfo.vip_Lv == 0) {
          return this.$message.info('您还不是会员,请先充值会员然后进行资源库导出')
        }



        this.loading = true
        // let page = this.pageindex
        let queryData = {
          PageIndex: this.pageNo,
          PageSize:this.pageSize,
          city:''
        }
        if(this.input) {
          queryData.key = this.input
        }
        if(this.city) {
          queryData.city = this.city[0] + '-' + this.city[1]
        }
        if(this.work) {
          queryData.trade_s =  this.work[1]
        }
        if(this.people) {
          queryData.cbnum = this.people
        }
        this.$store.dispatch('source/GetHomelist',queryData).then(res => {
          this.loading = false
          console.log('拿出来的是res   res是资讯库的数据导出',res)
          this.tableData = []
          this.tableData = res.data.Data




          const headers = ['企业名称', '法人', '联系电话','邮箱','官网','成立年限','地址','参保人数','注册资本']
          const data = this.tableData.map(item => [item.Company_Name, item.Legal_Person, item.Other_Tel,item.Email,item.Website,item.Establishment_Date,item.Last_Report_Address,item.Cb_Code,item.Registered_Capital])
          const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
          XLSX.writeFile(workbook, '资源库.xlsx')
        })

        




      },
      watchScroll() {
        if(this.loading) {
          return
        }
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let clientHeight = document.documentElement.clientHeight;
        // let scrollHeight = document.documentElement.scrollHeight;
        // console.log(scrollTop,clientHeight,scrollHeight)
        if (scrollTop + clientHeight >= (200+ this.pageindex * 1500)) {
          // console.log('到底啦')
          this.pageindex = this.pageindex + 1
          this.loading = true;
          this.getlist()
          // this.queryParams.pageNum+=1;
          // listCourseAll(this.queryParams).then(response => {
          //   if (response.rows.length != 0) {
          //     response.rows.forEach( (item)=> {
          //       this.courseList.push(item);
          //     });
          //     this.total = response.total;
          //   } else {
          //     this.queryParams.pageNum -= 1;
          //     if (response.rows.length == 0) {
          //       this.loading = false;
          //       this.isShow = true;
          //       //this.$message.warning("到底了");
          //     } else {
          //       this.$message.error("操作失败");
          //     }
          //   }
            this.loading = false;
          // });
        }

      },
      getlist() {
        let page = this.pageNo
        let queryData = {
          PageIndex: page,
          PageSize:this.pageSize,
          city:''
        }
        if(this.input) {
          queryData.key = this.input
        }
        if(this.city) {
          queryData.city = this.city[0] + '-' + this.city[1]
        }
        if(this.work) {
          queryData.trade_s =  this.work[1]
        }
        if(this.people) {
          queryData.cbnum = this.people
        }
        this.$store.dispatch('source/GetHomelist',queryData).then(res => {
          this.num = res.data.DataCount

          this.$refs?.token?.setmount(res.data.DataCount)
          console.log(res,'得到的所有的咨询')
          this.resourcelist = []
          res.data.Data.forEach(item => {
            item.contactNum = 0;
          item.Tel = item.Tel.split(';');
          for(var i=0;i<item.Tel.length;i++){
            if(item.Tel[i]=='-'){
              item.Tel.splice(i,1);
              i--;
            }
          }
          item.Other_Tel = item.Other_Tel.split(';');
          for(var j=0;j<item.Other_Tel.length;j++){
            if(item.Other_Tel[j]=='-'){
              item.Other_Tel.splice(j,1);
              j--;
            }
          }
          item.tels = item.tels?JSON.parse(item.tels):[];
          item.OtherContact=item.OtherContact==null?[]:JSON.parse(item.OtherContact);
          item.contactNum = item.Other_Tel.length + item.Tel.length + item.tels.length;
          item.contactNum = '(' + item.contactNum  + (item.OtherContact.length>0?('+' + item.OtherContact.length):'')+ ')';
          this.resourcelist.push(item)
          })


        })
      },
      getmount() {
        let queryData = {
          PageIndex: this.pageindex,
          PageSize:12,
          city:'北京市-北京市'
        }        
        this.$store.dispatch('source/GetHomelist',queryData).then(res => {
          this.$refs?.token?.setmount(res.data.DataCount)
        })
      },
      gotoSearch() {

        this.resourcelist = []
        // console.log('123',this.input)
        this.pageNo = 1
        this.getlist()
      },
        
      handleChangecity() {
        this.pageNo = 1
        this.resourcelist = []
        // console.log('123',this.input)
        // this.pageindex = 1
        this.getlist()
        this.fenleidetailcity = this.city[0] + '——' + this.city[1]
      },
      handleChangework() {
        this.pageNo = 1
        this.resourcelist = []
        // console.log('123',this.input)
        // this.pageindex = 1
        this.getlist()
        console.log(this.work,'看一下下面需要放的东西')
        this.fenleidetailwork = this.work[0] + '——' + this.work[1]
      },
      handleChangepeople() {
        this.pageNo = 1
        this.resourcelist = []
        // console.log('123',this.input)
        // this.pageindex = 1
        this.getlist()
        this.fenleidetailpeople = this.people[0]
      },

        // 拿到行业数据
        getwork() {
          this.$store.dispatch('source/GetList').then(res => {
            // console.log(res.data.Code,'行业能出来吗')
            // 行业打印了出来  那么之后  弄一个数组
            if(res.data.Code == 200) {
              // console.log(res.data.Data,'行业能出来吗')
              let work = res.data.Data
              this.optionswork = []
              work.forEach(element => {
                let obj = {}
                obj.value = element.name
                obj.label = element.name
                let arr = []
                element.children.forEach(item => {
                  let objthesecond = {}
                  objthesecond.label = item
                  objthesecond.value = item
                  arr.push(objthesecond)
                })
                obj.children = arr
                this.optionswork.push(obj)
                // console.log('看一看行业里面的数据',4564564564,'测试',this.optionswork)

              });
              // 在这里在行业这里加全部
              // let quanbuobj = {}
              // quanbuobj.value = '全部'
              // quanbuobj.label = '全部'
              // this.optionswork.unshift(quanbuobj)


            }
          })
        },
        Todetail(e) {
          // this.$router.push({name:'resourcedetail',params:{id:e}})


          let routeData = this.$router.resolve({ name:'resourcedetail', params: { id: e } });
          window.open(routeData.href, '_blank');
        }
    }
}
</script>
<style lang="scss" scoped>
.zhong {
    // background-color: black;
    margin: 0 auto;
    width: 60%;
    // height: 20px;
    margin-top: 20px;
    // overflow: auto;
    // height: 1000px;
  .block {
    width: 95%;
    // margin-left: 8%;
    display: flex; 
      // overflow: auto;
      // height: 1000px;
    .leftto5 {
      margin-left: 10px;
      background-color: #FFB658;
      color: #FFFAF3;
      border: 1px solid transparent;
      box-sizing: border-box;



    }
    
    .inputofelementui {
            // margin-left: 30px;
            ::v-deep {
            .el-input__inner {
                border: 1px solid #FFB658;               
            }
            .el-input-group__append {
                .el-button--primary {
                background-color: #FFB658;
                color: #FFFAF3;
                border-radius: 0 5px 5px 0;
                box-sizing: border-box;
                border: 1px solid transparent;
                }
            }
            }
            }
  }
  }
  .zhongtwo {
    display: flex;
    margin: 0 auto;
    width: 60%;
    justify-content: space-between;
    position: relative;
    // left: 54px;
    margin-top: 20px;
    .zhongtwodiv {
      flex: 0 0 33%;
    }
    .one{
      // margin-left: 8%;
    }

  }
  .fenlei {
        margin-top: 5px;
        // margin-left: 290px;
        color: #9E9E9E;
        font-size: 20px;
        .secondiconfont {
            margin-left: -5px;
        }
    }
  .companyItemCont {
    background-color: #ffffff;
    box-shadow: 3px 3px 2px #ccc;
    // margin-left: 8%;
    width: 98%;
    margin-top: 20px;
    cursor: pointer;
    .companyItem {
      display: flex;
      .head {
        width: 70px;
        height: 70px;
        color: #ffffff;
        text-align: center;
        background-color: #5D60D1;
        border-radius: 10px;
        line-height: 70px;
        font-size: 35px;
        margin-top: 10px;
        margin-left: 10px;

      }
      .info {
        flex: 1;
        margin: 10px 20px 0;
        .name {
          color: #808080;
          font-weight: 600;
          font-size: 20px;
        }
        .industry {
          color: #ACACAC;
          margin-top: 15px;

        }
      }
    }
    .companyItemTags {
      padding: 0 0 40px;
      margin-top: 15px;
      .ItemTags_r {
        float: right;
        color: #C2401C;
        background-color: #F4D9D2;
        padding: 2px 20px;
        border-radius: 15px 0 0 15px;

      }
      .ItemTags_l {
        background-color: #AEAFE5;
        color: #5C60D1;
        float: left;
        margin-left: 20px;
        padding: 2px 20px;
        border-radius: 15px 15px 15px 15px;

      }
    }
  }
  .el-pagination {
            margin-left: 23%;
            margin-top: 50px;
        }
        ::v-deep {
            .el-pagination__rightwrapper {
                margin-right: 30%;
            }

        }

    ::v-deep {

      .el-pagination__jump {
        margin-right: 24px;
      }
    }
</style>